import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
	? loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
	: null;
